import { PackageJSON } from '@alilc/lowcode-types';

import { COMMON_CHUNK_NAME } from '../../../../../const/generator';

import {
  BuilderComponentPlugin,
  BuilderComponentPluginFactory,
  ChunkType,
  FileType,
  ICodeStruct,
  IProjectInfo,
} from '../../../../../types';
import { buildDataSourceDependencies } from '../../../../../utils/dataSource';

interface IIceJsPackageJSON extends PackageJSON {
  peerDependencies :Record<string, string>;
  eslintConfig: {
    extends: [string,string];
  };
  browserslist: {
    production: [string,string,string];
    development: [string,string,string];
  };

}

export type IceJsPackageJsonPluginConfig = {
  /**
   * 数据源配置
   */
  datasourceConfig?: {
    /** 数据源引擎的版本 */
    engineVersion?: string;
    /** 数据源引擎的包名 */
    enginePackage?: string;
    /** 数据源 handlers 的版本 */
    handlersVersion?: {
      [key: string]: string;
    };
    /** 数据源 handlers 的包名 */
    handlersPackages?: {
      [key: string]: string;
    };
  };
  /** 包名 */
  packageName?: string;
  /** 版本 */
  packageVersion?: string;
};

const pluginFactory: BuilderComponentPluginFactory<IceJsPackageJsonPluginConfig> = (cfg) => {
  const plugin: BuilderComponentPlugin = async (pre: ICodeStruct) => {
    const next: ICodeStruct = {
      ...pre,
    };

    const ir = next.ir as IProjectInfo;

    const packageJson: IIceJsPackageJSON = {
      name: cfg?.packageName || 'create-react-app-antd',
      version: cfg?.packageVersion || '0.1.0',
      description: 'normal react',
      peerDependencies: {
        "react-sortablejs": "~6.0.0"
      },
      dependencies: {
        react: '^17.0.2',
        "@craco/craco": "^6.4.3",
        "@testing-library/jest-dom": "^5.14.1",
        "@testing-library/react": "^12.0.0",
        "@testing-library/user-event": "^13.2.1",
        "antd": "^4.19.2",
        "craco-less": "^2.0.0",
        "query-string": "^7.1.1",
        "react-dom": "^17.0.2",
        "react-router-dom": "^5.3.4",
        "react-scripts": "5.0.0",
        "web-vitals": "^2.1.0",

        // 数据源相关的依赖:
        ...buildDataSourceDependencies(ir, cfg?.datasourceConfig),
        "react-sortablejs": "~6.0.0"
      },
      devDependencies: {
        "craco-alias": "^3.0.1",
        "@craco/craco": "^7.0.0",
        "@testing-library/jest-dom": "^5.16.5",
        "@testing-library/react": "^13.4.0",
        "@testing-library/user-event": "^14.4.3",
      },
      scripts: {
        "start": "craco start",
        "build": "craco build",
        "test": "craco test"
      },
      private: true,
      browserslist: {
        "production": [
          ">0.2%",
          "not dead",
          "not op_mini all"
        ],
        "development": [
          "last 1 chrome version",
          "last 1 firefox version",
          "last 1 safari version"
        ]
      },
      eslintConfig: {
        "extends": [
          "react-app",
          "react-app/jest"
        ]
      },
    };

    ir.packages.forEach((packageInfo) => {
      console.log("dependencies.................")
      console.log(packageInfo.package)
      packageJson.dependencies[packageInfo.package] = packageInfo.version;
    });

    next.chunks.push({
      type: ChunkType.JSON,
      fileType: FileType.JSON,
      name: COMMON_CHUNK_NAME.FileMainContent,
      content: packageJson,
      linkAfter: [],
    });

    return next;
  };
  return plugin;
};

export default pluginFactory;
